export interface CaseNoteData {
    besked: string
    kanSlettes: boolean
    notatId: string
    oprettetAfNavn: string
    oprettetTid: string
}

export class CaseNote {
    id = ''

    createdAt?: string

    message = ''

    isDeletable = false

    createdBy = ''

    static build(data: CaseNoteData): CaseNote {
        const caseNote = new CaseNote()
        caseNote.id = data.notatId
        caseNote.message = data.besked
        caseNote.createdAt = data.oprettetTid || undefined
        caseNote.isDeletable = data.kanSlettes
        caseNote.createdBy = data.oprettetAfNavn
        return caseNote
    }
}
